import React from 'react';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import 'src/components/DashboardCard/DashboardCard.css';

interface DashboardCardProps {
    id: string;
    title: string;
    description?: string;
    onClick?: (e: React.MouseEvent) => void;
}

function DashboardCard({ id, title, description, onClick }: DashboardCardProps): FunctionComponentReturnType {
    return (
        <button id={id} className="dashboard-card" onClick={onClick} type="button" aria-label={title}>
            <div className="dashboard-card-content">
                <h4 className="dashboard-card-title">{title}</h4>
                <div className="dashboard-card-text">
                    {description && <p className="dashboard-card-description">{description}</p>}
                </div>
            </div>
            <div className="dashboard-card-footer">
                <svg className="dashboard-card-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        </button>
    );
}

export default DashboardCard;
